import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { KontaktoplysningerPopupIndstillinger } from "./kontaktoplysninger-popup-content/kontaktoplysninger-popup-content.model";

@Injectable({ providedIn: "root" })
export class KontaktoplysningerPopupRepository {
    constructor(private readonly umbracoHttpClient: UmbracoHttpClient) {}
    public hentIndstillinger(): Observable<KontaktoplysningerPopupIndstillinger> {
        return this.umbracoHttpClient.hentSideData("").pipe(
            map((value) => ({
                visKampagne: value.kontaktoplysningerKampagne === "1"
            })),
            shareReplay(1)
        );
    }
}
